import axios from 'axios';

export const request = (url, data) => {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {headers: {'Content-Type': 'application/json'}})
            .then((res) => {
                resolve(res);
            })
            .catch((res) => {
                reject(res);
            })
    });
}

export const requestTimeOut = (url, data, timeout) => {
    return new Promise((resolve, reject) => {
        const source = axios.CancelToken.source();
        const timer = setTimeout(() => {
            source.cancel('请求超时');
            reject(new Error('请求超时'));
        }, timeout);

        axios.post(url, data, {
            headers: {'Content-Type': 'application/json'},
            cancelToken: source.token
        })
            .then((res) => {
                clearTimeout(timer);
                resolve(res);
            })
            .catch((error) => {
                if (axios.isCancel(error)) {
                    // 请求被取消（超时），不进行额外的错误处理
                } else {
                    // 其他错误，进行正常的错误处理
                    reject(error);
                }
            });
    });
};

export const requestPost = (url, data) => {
    let param = {
        param : data,
        channel : 'backend'
    }
    return new Promise((resolve, reject) => {
        axios.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}})
            .then((res) => {
                resolve(res);
            })
            .catch((res) => {
                reject(res);
            })
    });
}

export const requestMedia = (url) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'GET', // 请求方式
            url: url,
            data: {

            },
            responseType: 'blob' // 服务器返回的数据类型
        })
        .then((res) => {
            resolve(res);
        })
        .catch((res) => {
            reject(res);
        })
    });
};


export const requestGet = (url, data) => {
    return new Promise((resolve, reject) => {
        axios.get(url, data)
        .then((res) => {
            resolve(res);
        })
        .catch((res) => {
            reject(res);
        })
    });
};

export const requestMedia2 = (url,data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST', // 请求方式
            url: url + '?groupDate=' + data,
            responseType: 'blob' // 服务器返回的数据类型
        },data)
            .then((res) => {
                resolve(res);
            })
            .catch((res) => {
                reject(res);
            })
    });
};

export const requestMedia3 = (url,data) => {
    return new Promise((resolve, reject) => {
        axios({
            method: 'POST', // 请求方式
            url: url,
            responseType: 'arraybuffer' // 服务器返回的数据类型
        },data)
            .then((res) => {
                resolve(res);
            })
            .catch((res) => {
                reject(res);
            })
    });
};


// WEBPACK FOOTER //
// ./src/libs/axios/request.js